import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import jwt_decode from "jwt-decode";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import DatePicker from "react-datepicker";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var yesterday = new Date(Date.now() + 0 * 40 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');

class CreateSupportTicket extends Component {
    render() {
        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Create Support Ticket</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="clearfix"></div>

                                    <div className=" content bgcolor">
                                        <div className=" container-fluid ">

                                            <div className="p-10">

                                                <div className="">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="col-md-8">
                                                                <div className="col-md-3">
                                                                    <label>Requestor Email: </label> <span className="red req" ><small>*</small></span>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <input name="requestorEmail" className="form-control"  value={''} />
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label> UTID: </label> <span className="red req" ><small>*</small></span>
                                                                </div>

                                                                <div className="col-md-5">

                                                                    <select id="UTID" name="ProductName" className="form-control"
                                                                            >
                                                                        <option value="Select...">Select[UTID]</option>

                                                                    </select>

                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label> Store Name: </label> <span className="red req" ><small>*</small></span>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <select id="StoreName" name="ProductName" className="form-control"
                                                                    >
                                                                        <option value="Select...">Select[Store Name]</option>

                                                                    </select>
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label>Subject:</label> <span className="red req" ><small>*</small></span>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <input name="Subject" className="form-control " value={''} />
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>

                                                                <div className="col-md-3">
                                                                    <label>Issue Description:</label> <span className="red req" ><small>*</small></span>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <textarea id="IssueDescription" name="comment" className="form-control" rows="4" cols="50" >
  </textarea>

                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-12 invetoryTextCenter">
                                                                    <hr />
                                                                    <button type="button" id="OrderPlacementSubmit" className="btn btn-primary"   >Submit
                                                                    </button>
                                                                    {' '}


                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 " >

                                                            </div>
                                                        </div>
                                                        <div className="">

                                                            <div className="clearfix"></div>
                                                            <div className="gap_ver"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>



                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateSupportTicket;